module.exports = (window.__publicpath__ || __webpack_public_path__) + "static/media/DiamondDotted.4ebad774.svg";